<template lang="pug">
.filters-bar(v-if="filtered")
  .chips
    nuxt-link.chip(
      v-for="i, k in filters"
      :key="k"
      :to="i.to"
      v-if="i.label"
      v-tooltip="'Remove this filter'")
      span.name.pf-ellipsis(v-text="i.label")
      span.times &times;

    nuxt-link.chip.reset(:to="{ query: {} }")
      span.name Clear all filters
</template>

<script>
import { isEqual } from 'lodash'
import { QUERY_STRUCTURE, getDefaultQuery, deserializeQuery } from '~/utilities/catalog'

export default {
  computed: {
    applied () {
      const defaultQuery = getDefaultQuery()
      const params = deserializeQuery(this.$route.query)
      return Object
        .keys(params)
        .reduce((res, key) => {
          const value = params[key]
          const def = QUERY_STRUCTURE[key]
          const ignored = !def || isEqual(value, defaultQuery[key])
          if (!ignored) res[key] = value
          return res
        }, {})
    },

    filters () {
      return Object
        .keys(this.applied)
        .reduce((res, key) => {
          const value = this.applied[key]
          const def = QUERY_STRUCTURE[key]
          if (!def) return res
          switch (def.type) {
            case Array:
              value.forEach(item => {
                res.push(this.getQueryPiece(key, item, value))
              })
              break
            default:
              res.push(this.getQueryPiece(key, value))
          }
          return res
        }, [])
    },

    filtered () {
      return Object
        .keys(this.applied)
        .filter(key =>
          !QUERY_STRUCTURE[key].invisible ||
          this.applied[key].label !== null)
        .length > 0
    }
  },

  methods: {
    getQueryLabel (key, value) {
      const def = QUERY_STRUCTURE[key]
      if (!def || !def.label) return value
      return def.label(value)
    },

    getQueryPiece (key, item, all = null) {
      const query = {
        ...this.applied
      }
      delete query[key]
      if (Array.isArray(all)) query[key] = all.filter(i => i !== item)
      return {
        key,
        value: item,
        label: this.getQueryLabel(key, item),
        to: this.$links.catalog({ query })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filters-bar {
  margin-bottom: 1em;
  .chips {
    display: flex;
    flex-wrap: wrap;
    .chip {
      background: #e9edf1;
      font-size: 14px;
      line-height: 1em;
      padding: 6px 10px;
      border-radius: 1000px;
      white-space: nowrap;
      color: $--color-text-regular;
      margin-bottom: 10px;
      &:not(:last-child) {
        margin-right: 10px;
      }
      &.reset {
        background: white;
        border: 1px solid #e9edf1;
      }
      .name {
        max-width: 120px;
      }
      .times {
        color: #b6b6c8;
        font-size: 16px;
        margin-left: 6px;
      }
    }
  }
}
</style>
